/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';
import { ON_NOTIFY_WORKER_CREATION } from './subscriptions/process';
import { ON_NOTIFY_KCHAT_MESSAGE_UPDATE } from './subscriptions/koncierge';

const onWorkerKnowledgeIdUpdate = /* GraphQL */ `
  subscription onWorkerKnowledgeIdUpdate($id: ID!) {
    onNotifyWorkerUpdate(id: $id) {
      id
      knowledgeId
    }
  }
`;

const onProcedureWorkersStateUpdate = /* GraphQL */ `
  subscription onProcedureWorkersStateUpdate($procedureId: ID) {
    onNotifyWorkerUpdate(procedureId: $procedureId) {
      id
      state
    }
  }
`;

const Subscriptions = {
  onWorkerKnowledgeIdUpdate() {
    return gql(onWorkerKnowledgeIdUpdate);
  },

  onProcedureWorkersStateUpdate() {
    return gql(onProcedureWorkersStateUpdate);
  },

  onWorkerCreation() {
    return ON_NOTIFY_WORKER_CREATION;
  },

  OnNotifyKChatMessageUpdate() {
    return ON_NOTIFY_KCHAT_MESSAGE_UPDATE;
  }
};

export default Subscriptions;
